type Props = {
  className?: string;
};

const ChevronBack = ({ className = '' }: Props) => (
  <svg
    focusable={false}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    width='72'
    height='72'
    viewBox='0 0 72 72'
  >
    <path
      fill='none'
      fillRule='evenodd'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M45 54L27 36l18-18'
    />
  </svg>
);

export default ChevronBack;
